import { createFileRoute, Outlet } from '@tanstack/react-router';
import { checkSecurityDomain } from '../utils/auth';

export const Route = createFileRoute('/team-insights')({
  component: RouteComponent,
  beforeLoad: checkSecurityDomain({
    routeObject: 'analytics',
  }),
});

function RouteComponent() {
  return (
    <div className="min-h-screen">
      <Outlet />
    </div>
  );
}
